package com.fireavert.react.pages.my_fire_risk

import com.fireavert.fire_risk.data_models.RiskLevel
import react.FC
import react.dom.html.ReactHTML

val RiskTableKey = FC {
    ReactHTML.div {
        className = FireRiskStyles.whiteBox
        ReactHTML.div {
            className = FireRiskStyles.riskArrowStyle
            ReactHTML.span {
                className = FireRiskStyles.riskTablePadding
                +"Low Risk"
            }
            ReactHTML.img {
                className = FireRiskStyles.arrowStyle
                src = "/static/my_fire_risk_assets/arrow.svg"
                alt = "----->"
            }
            ReactHTML.span {
                className = FireRiskStyles.riskTablePadding
                +"High Risk"
            }
        }
        ReactHTML.div {
            className = FireRiskStyles.riskLevelPadding
            RiskLevel.entries.forEach { riskLevel ->
                ReactHTML.span {
                    className = FireRiskStyles.riskLevelEntry(riskLevel.color)
                    +riskLevel.number.toString()
                }
            }
        }
    }

}